import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../../images/case-studies/martbook/banner_back.webp";

function Banner() {
  return (
    <section
      className="banner_mart"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <h1 style={{ color: "#000" }}>
              <span style={{ color: "#259354" }}>Mart Book</span> – mobile app
              development
            </h1>
            <p>Revolutionizing livestock farming for modern-day farmers.</p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Banner;
